import DashboardPage       from './dashboard_page';
import EmptyPage           from '../components/empty_page';
import Invoice             from '../invoices/invoices_page';
import PrivateFeedbackPage from './private_feedback_page';
import renderPage          from '../components/render_page';
import ReviewsPage         from './reviews_page';
import ScorecardPage       from './scorecard_page';
import Tab                 from './tab';

export default {
  path:         '/:businessID/metrics',
  component:    renderPage(EmptyPage),
  onlyTab:      true,
  name:         'Metrics',
  tabComponent: {
    component: Tab,
    name:      'metrics'
  },
  routes: [
    {
      path:         'invoices',
      name:         'Invoices & Payouts',
      component:    renderPage(Invoice.InvoicesPage),
      tabComponent: {
        component: Tab,
        name:      'metrics'
      },
      routes: [
        {
          name:         'InvoiceDetail',
          path:         ':invoiceID',
          component:    renderPage(Invoice.DetailPage),
          tabComponent: {
            component: Tab,
            name:      'metrics'
          }
        }
      ]
    },
    {
      path:         'private-feedback',
      name:         'PrivateFeedback',
      component:    renderPage(PrivateFeedbackPage),
      tabComponent: {
        component: Tab,
        name:      'metrics'
      }
    },
    {
      path:         'reviews',
      name:         'Reviews',
      component:    renderPage(ReviewsPage),
      tabComponent: {
        component: Tab,
        name:      'metrics'
      }
    },
    {
      path:         'scorecard',
      name:         'TeamScorecard',
      component:    renderPage(ScorecardPage),
      tabComponent: {
        component: Tab,
        name:      'metrics'
      }
    },
    {
      path:         'dashboard',
      name:         'Dashboard',
      component:    renderPage(DashboardPage),
      tabComponent: {
        component: Tab,
        name:      'metrics'
      }
    }
  ]
};
